// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_YUy","cls2":"RelatedPapers-cls2_G9l RelatedPapers-cls1_YUy"};